
// import { Suspense, lazy } from "react";
// import "./Home.css";

// // import jmk2025 from '../../assets/images/JMK Re 25.jpg';

// // import jmkReport from '../../assets/images/jmk.jpeg';
// // import crisilBridge from '../../assets/images/crisilBridge.webp';
// // import gautamSolarRank from '../../assets/images/gautamSolarRank.webp';
// // import New2 from "../../assets/images/new2.jpg"

// import FAQ from "../../component/faq/FAQ";
// import { Helmet } from "react-helmet";
// import WhyChooseGautamSolar from "../../component/solarpanel/SolarPanel";
// import AmongTopSolar from "../../component/amongtopsolar/AmongTopSolar";
// import Kiwi from "../../component/Kiwi";
// import Slider from "../../component/Slider/Slider";

// // Lazy-loaded components
// const VideoSecond = lazy(() => import("../../component/videosecond/VideoSecond"));

// const SolarMod = lazy(() => import("../../component/solarmod/SolarMod"));
// const Factories = lazy(() => import("../../component/factories/Factories"));
// const SliderFirst = lazy(() => import("../../component/sliderfirst/SliderFirst"));
// const ContactBox = lazy(() => import("../../component/enquiry/ContactBox"));



// function Home() {

//   const topSolar = [
//     { title: ' JMK Research & Analytics', desc: 'RE Update FY 2025', img: '/TOP_10_JMK.webp', alt: 'Top 10 Solar ' },
//     // { title: ' JMK Research & Analytics', desc: ' RE Update Q3 2025.', img: '/Top_8.webp', alt: 'Top 10 solar module' },
//     { title: ' JMK Research & Analytics', desc: 'Among India Top 10 Solar Module Manufacturers', img: '/top10.jpeg', alt: 'Top 10 solar module' },
//     // { title: ' JMK Research & Analytics', desc: ' RE Update Q4 2025.', img: '/JKM_Ranked.jpeg', alt: 'Top 10 solar module' },
//     { title: ' CRISIL Bridge To India', desc: 'India PV Module Intelligence Brief | Q4 2024', img: '/Crisil.webp', alt: 'Top 10 solar ' },
//     // { title: ' JMK 2024', desc: 'RE Update Q4 2024', img: '/JMK_Q4.webp', alt: 'Top 10 Solar ' },
//   ]


//   // const topSolar2 = [
//   //   { img: '/Grade_A.webp' },
//   //   { img: '/Global_Top_30.webp' },
//   // ]

//   const heading = "AMONG INDIA'S";
//   const subHeading = "TOP 10 SOLAR MODULE MANUFACTURERS"

//   return (
//     <>
//       <Helmet>
//         <title>Top 10 Solar Module Manufacturers company in india</title>
//         <meta
//           name="description"
//           content="Searching for the Best Top 10 Solar Module Manufacturers company in India? Gautam Solar is among the most reliable solar companies, boasting over 25 years of experience. The company specialises in producing high-efficiency solar modules, including Mono PERC and state-of-the-art N-Type TOPCon panels. "
//         />
//         <meta
//           name="keywords"
//           content="Top Solar Module Plant, Top 10 Solar Module Manufacturers company in india, India Solar Manufacturer company, Solar panels, solar manufacturing company in india"
//         />
//       </Helmet>
//       <h1 className="sr-only">AMONG INDIA'S TOP 10 SOLAR MODULE MANUFACTURERS</h1>

//       <Slider />

//       <Suspense
//         fallback={
//           <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
//             <div className="spinner-border" role="status" style={{ color: '#a20000' }}>
//               <span className="visually-hidden">Loading...</span>
//             </div>
//           </div>
//         }
//       >
//         <VideoSecond />
//         <AmongTopSolar
//           heading={heading}
//           subHeading={subHeading}
//           topSolar={topSolar} />
//         <SolarMod />
//         <Kiwi />
//         <WhyChooseGautamSolar />
//         <Factories />

//         <SliderFirst />
//         <FAQ />
//         <ContactBox />
//       </Suspense>
//     </>
//   );
// }

// export default Home;



import { Suspense, lazy, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import "./Home.css";
import FAQ from "../../component/faq/FAQ";
import { Helmet } from "react-helmet";
import WhyChooseGautamSolar from "../../component/solarpanel/SolarPanel";
import AmongTopSolar from "../../component/amongtopsolar/AmongTopSolar";
import Kiwi from "../../component/Kiwi";
import Slider from "../../component/Slider/Slider";

// Lazy-loaded components
const VideoSecond = lazy(() => import("../../component/videosecond/VideoSecond"));

const SolarMod = lazy(() => import("../../component/solarmod/SolarMod"));
const Factories = lazy(() => import("../../component/factories/Factories"));
const SliderFirst = lazy(() => import("../../component/sliderfirst/SliderFirst"));
const ContactBox = lazy(() => import("../../component/enquiry/ContactBox"));



function Home() {

  const topSolar = [
    { title: ' JMK Research & Analytics', desc: 'RE Update FY 2026', img: '/top-4.jpeg', alt: 'Top 4 Solar ' },

    { title: ' JMK Research & Analytics', desc: 'RE Update FY 2025', img: '/TOP_10_JMK.webp', alt: 'Top 10 Solar ' },
    // { title: ' JMK Research & Analytics', desc: ' RE Update Q3 2025.', img: '/Top_8.webp', alt: 'Top 10 solar module' },
    { title: ' JMK Research & Analytics', desc: 'Among India Top 10 Solar Module Manufacturers', img: '/top10.webp', alt: 'Top 10 solar module' },
    // { title: ' JMK Research & Analytics', desc: ' RE Update Q4 2025.', img: '/JKM_Ranked.jpeg', alt: 'Top 10 solar module' },
    { title: ' CRISIL Bridge To India', desc: 'India PV Module Intelligence Brief | Q4 2024', img: '/Crisil.webp', alt: 'Top 10 solar ' },
    // { title: ' JMK 2024', desc: 'RE Update Q4 2024', img: '/JMK_Q4.webp', alt: 'Top 10 Solar ' },
  ]


  // const topSolar2 = [
  //   { img: '/Grade_A.webp' },
  //   { img: '/Global_Top_30.webp' },
  // ]

  const heading = "AMONG INDIA'S";
  const subHeading = "TOP 4 SOLAR MANUFACTURERS"

  return (
    <>
      <Helmet>
        <title>Top 10 Solar Module Manufacturers company in india</title>
        <meta
          name="description"
          content="Searching for the Best Top 10 Solar Module Manufacturers company in India? Gautam Solar is among the most reliable solar companies, boasting over 25 years of experience. The company specialises in producing high-efficiency solar modules, including Mono PERC and state-of-the-art N-Type TOPCon panels. "
        />
        <meta
          name="keywords"
          content="Top Solar Module Plant, Top 10 Solar Module Manufacturers company in india, India Solar Manufacturer company, Solar panels, solar manufacturing company in india"
        />

        <link rel="canonical" href="https://gautamsolar.com/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Gautam Solar",
            url: "https://gautamsolar.com/",
            logo: "https://gautamsolar.com/Round Corner Logo0 (1).png",
            description:
              "Gautam Solar is a leading ALMM-listed solar panel manufacturer in India with over 25 years of experience, specializing in Mono PERC and N-Type TOPCon solar modules.",
            address: {
              "@type": "PostalAddress",
              streetAddress: "D-120-121, Okhla Industrial Area, Phase-1",
              addressLocality: "New Delhi",
              postalCode: "110020",
              addressCountry: "IN",
            },
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-93117-97248",
              contactType: "customer service",
              email: "info@gautamsolar.com",
            },
            sameAs: [
              "https://www.facebook.com/gautamsolarprivatelimited",
              "https://www.instagram.com/gautam_solar/",
              "https://www.linkedin.com/company/gautam-solar-group/",
              "https://www.youtube.com/@GautamSolarOfficial",
            ],
          })}

        </script>
      </Helmet>
      <h1 className="sr-only">AMONG INDIA'S TOP 4 SOLAR MODULE MANUFACTURERS</h1>

      <Slider />

      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
            <div className="spinner-border" role="status" style={{ color: '#a20000' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      >
        <VideoSecond />
        <AmongTopSolar
          heading={heading}
          subHeading={subHeading}
          topSolar={topSolar} />
        <SolarMod />
        <Kiwi />
        <WhyChooseGautamSolar />
        <CombinedInverterBessSection />
        {/* <BessSection /> */}
        <Factories />

        <SliderFirst />
        <FAQ />
        <ContactBox />
      </Suspense>
    </>
  );
}

export default Home;



const CombinedInverterBessSection = () => {
  const navigate = useNavigate();
  const theme = '#a20000'; // Exact 6-digit hex code
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  // --- Main Section ---
  const sectionStyle = {
    padding: isMobile ? '60px 16px' : '100px 24px',
    backgroundColor: '#fafafa',
    fontFamily: '"Inter", "Segoe UI", Roboto, Arial, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  };

  // --- Centered Header ---
  const headerWrapperStyle = {
    textAlign: 'center',
    marginBottom: '48px',
    maxWidth: '800px'
  };

  const mainHeadingStyle = {
    fontSize: isMobile ? '32px' : '46px',
    fontWeight: '800',
    color: '#1a1a1a',
    margin: '0 0 16px 0',
    letterSpacing: '-0.02em',
    textTransform: 'uppercase'
  };

  const subTitleStyle = {
    fontSize: isMobile ? '15px' : '17px',
    color: '#666',
    lineHeight: '1.6',
    margin: 0
  };

  // --- White Card Container ---
  const cardContainerStyle = {
    width: '100%',
    maxWidth: '1000px',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    border: '1px solid #eaeaea',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.04)',
    padding: isMobile ? '32px 20px' : '56px 48px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  };

  // --- Badge Style ---
  const badgeStyle = {
    backgroundColor: theme,
    color: '#ffffff',
    padding: '8px 20px',
    borderRadius: '100px',
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '48px',
    display: 'inline-block'
  };

  // --- Product Block Styles (Stacked) ---
  const productBlockStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%'
  };

  const productTitleStyle = {
    fontSize: isMobile ? '24px' : '28px',
    fontWeight: '700',
    color: '#1a1a1a',
    marginBottom: '24px',
    marginTop: 0
  };

  const upcomingTagStyle = {
    backgroundColor: 'rgba(162, 0, 0, 0.08)',
    color: theme,
    padding: '6px 14px',
    borderRadius: '100px',
    fontSize: '12px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '12px',
    display: 'inline-block'
  };

  const imageWrapperStyle = {
    width: '100%',
    maxWidth: '600px',
    aspectRatio: '16/9',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #f0f0f0',
    marginBottom: '32px'
  };

  // --- Specs Grid (2 columns inside the stacked block for better space usage) ---
  const specsGridStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
    gap: '16px 32px',
    width: '100%',
    maxWidth: '800px',
    textAlign: 'left',
    marginBottom: '40px'
  };

  const specItemStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    fontSize: '15px',
    lineHeight: '1.6',
    color: '#444'
  };

  const bulletStyle = {
    color: theme,
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '1.4'
  };

  const buttonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '16px 40px',
    backgroundColor: theme,
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 14px rgba(162, 0, 0, 0.2)',
    width: isMobile ? '100%' : 'auto'
  };

  const dividerStyle = {
    width: '100%',
    height: '1px',
    backgroundColor: '#eaeaea',
    margin: '64px 0'
  };

  const handleInverterClick = () => navigate('/inverter');
  const handleBessClick = () => navigate('/bess');

  const handleHover = (e, isHovering) => {
    if (isMobile) return;
    if (isHovering) {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 8px 24px rgba(162, 0, 0, 0.35)';
    } else {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 4px 14px rgba(162, 0, 0, 0.2)';
    }
  };

  return (
    <section style={sectionStyle}>
      
      {/* Centered Heading Section */}
      <div style={headerWrapperStyle}>
        <h2 style={mainHeadingStyle}>
          INVERTER & <span style={{ color: theme }}>BESS</span>
        </h2>
        <p style={subTitleStyle}>
          Explore our comprehensive range of reliable solar inverters and advanced battery energy storage systems.
        </p>
      </div>

      {/* White Card Container */}
      <div style={cardContainerStyle}>
        
        <span style={badgeStyle}>PRODUCT OVERVIEW</span>

        {/* ================= INVERTER BLOCK (TOP) ================= */}
        <div style={productBlockStyle}>
          <h3 style={productTitleStyle}>Solar Inverters</h3>
          
          <div style={imageWrapperStyle}>
            {/* REPLACE THIS SVG WITH YOUR ACTUAL IMAGE */}
            <img
            src="inverterSection.webp"
            alt="Gautam Solar Inverter"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
          </div>

          <div style={specsGridStyle}>
            <div style={specItemStyle}>
              <span style={bulletStyle}>→</span>
              <span>Available in 3 kW and 5 kW models with MPPT technology.</span>
            </div>
            <div style={specItemStyle}>
              <span style={bulletStyle}>→</span>
              <span>Maximum efficiency of up to 97.5% and MPPT efficiency above 99%.</span>
            </div>
            <div style={specItemStyle}>
              <span style={bulletStyle}>→</span>
              <span>Wi-Fi and RS485 communication for compatible monitoring systems.</span>
            </div>
            <div style={specItemStyle}>
              <span style={bulletStyle}>→</span>
              <span>IP65 enclosure protection against dust and water ingress.</span>
            </div>
          </div>

          <button
            style={buttonStyle}
            onClick={handleInverterClick}
            onMouseEnter={(e) => handleHover(e, true)}
            onMouseLeave={(e) => handleHover(e, false)}
          >
            Explore Inverters
            <span style={{ fontSize: '18px', lineHeight: 1 }}>→</span>
          </button>
        </div>

        {/* Divider Line */}
        <div style={dividerStyle}></div>

        {/* ================= BESS BLOCK (BOTTOM) ================= */}
        <div style={productBlockStyle}>
          {/* Small Tag above BESS Title */}
          <span style={upcomingTagStyle}>Upcoming in 2027</span>
          
          <h3 style={productTitleStyle}>Battery Energy Storage Systems</h3>
          
          <div style={imageWrapperStyle}>
            {/* REPLACE THIS SVG WITH YOUR ACTUAL IMAGE */}
            <img
            src="bessSection-1.webp"
            alt="Gautam Solar BESS"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          </div>

          <div style={specsGridStyle}>
            <div style={specItemStyle}>
              <span style={bulletStyle}>→</span>
              <span>Modular architecture designed to scale with changing project requirements.</span>
            </div>
            <div style={specItemStyle}>
              <span style={bulletStyle}>→</span>
              <span>Advanced LFP chemistry with multi-layer protection and real-time monitoring.</span>
            </div>
            <div style={specItemStyle}>
              <span style={bulletStyle}>→</span>
              <span>C&I solution: 125 kW / 261.2 kWh capacity, 90% DoD, IP55 rating.</span>
            </div>
            <div style={specItemStyle}>
              <span style={bulletStyle}>→</span>
              <span>Utility-scale solution: GS-5000-LC model, 5,015 kWh capacity, 8,000 cycles.</span>
            </div>
          </div>

          <button
            style={buttonStyle}
            onClick={handleBessClick}
            onMouseEnter={(e) => handleHover(e, true)}
            onMouseLeave={(e) => handleHover(e, false)}
          >
            Explore BESS
            <span style={{ fontSize: '18px', lineHeight: 1 }}>→</span>
          </button>
        </div>

      </div>
    </section>
  );
};

// const InverterSection = () => {

//   const navigate = useNavigate();
//   const theme = '#a20000'; // Exact 6-digit hex code
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkScreen = () => setIsMobile(window.innerWidth <= 768);
//     checkScreen();
//     window.addEventListener('resize', checkScreen);
//     return () => window.removeEventListener('resize', checkScreen);
//   }, []);

//   // --- Main Section ---
//   const sectionStyle = {
//     padding: isMobile ? '60px 16px' : '100px 24px',
//     backgroundColor: '#ffffff',
//     fontFamily: '"Inter", "Segoe UI", Roboto, Arial, sans-serif',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center'
//   };

//   // --- Header Styles (Matching the screenshot) ---
//   const headerWrapperStyle = {
//     textAlign: 'center',
//     marginBottom: '48px',
//     maxWidth: '800px'
//   };

//   const mainHeadingStyle = {
//     fontSize: isMobile ? '32px' : '46px',
//     fontWeight: '800',
//     color: '#1a1a1a',
//     margin: '0 0 16px 0',
//     letterSpacing: '-0.02em',
//     textTransform: 'uppercase'
//   };

//   const subTitleStyle = {
//     fontSize: isMobile ? '15px' : '17px',
//     color: '#666',
//     lineHeight: '1.6',
//     margin: 0
//   };

//   // --- Card Container Styles (Matching the white box in the screenshot) ---
//   const cardContainerStyle = {
//     width: '100%',
//     maxWidth: '1000px',
//     backgroundColor: '#ffffff',
//     borderRadius: '16px',
//     border: '1px solid #eaeaea',
//     boxShadow: '0 8px 30px rgba(0, 0, 0, 0.04)',
//     padding: isMobile ? '32px 20px' : '48px',
//     position: 'relative',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center'
//   };

//   // --- Badge Style (Matching the "CERTIFIED RECOGNITION" badge) ---
//   const badgeStyle = {
//     backgroundColor: theme,
//     color: '#ffffff',
//     padding: '8px 20px',
//     borderRadius: '100px',
//     fontSize: '12px',
//     fontWeight: '700',
//     letterSpacing: '1px',
//     textTransform: 'uppercase',
//     marginBottom: '32px',
//     display: 'inline-block'
//   };

//   // --- Content Grid ---
//   const contentGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//     gap: isMobile ? '32px' : '48px',
//     width: '100%',
//     alignItems: 'center'
//   };

//   const imageWrapperStyle = {
//     width: '100%',
//     aspectRatio: '4/3',
//     backgroundColor: '#f8f9fa',
//     borderRadius: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     border: '1px solid #f0f0f0'
//   };

//   const specsWrapperStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px'
//   };

//   const specItemStyle = {
//     display: 'flex',
//     alignItems: 'flex-start',
//     gap: '12px',
//     fontSize: '15px',
//     lineHeight: '1.6',
//     color: '#444'
//   };

//   const bulletStyle = {
//     color: theme,
//     fontWeight: '700',
//     fontSize: '18px',
//     lineHeight: '1.4'
//   };

//   const buttonStyle = {
//     marginTop: '40px',
//     display: 'inline-flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '10px',
//     padding: '16px 40px',
//     backgroundColor: theme,
//     color: '#ffffff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '16px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 4px 14px rgba(162, 0, 0, 0.2)',
//     width: isMobile ? '100%' : 'auto'
//   };

//   const handleClick = () => navigate('/products/inverters');

//   const handleHover = (e, isHovering) => {
//     if (isMobile) return;
//     if (isHovering) {
//       e.currentTarget.style.transform = 'translateY(-2px)';
//       e.currentTarget.style.boxShadow = '0 8px 24px rgba(162, 0, 0, 0.35)';
//     } else {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = '0 4px 14px rgba(162, 0, 0, 0.2)';
//     }
//   };

//   return (
//     <section style={sectionStyle}>
      
//       {/* Centered Heading Section */}
//       <div style={headerWrapperStyle}>
//         <h2 style={mainHeadingStyle}>
//           SOLAR & <span style={{ color: theme }}>INVERTERS</span>
//         </h2>
//         <p style={subTitleStyle}>
//           Efficient power conversion for residential, commercial, and utility-scale solar installations.
//         </p>
//       </div>

//       {/* White Card Container */}
//       <div style={cardContainerStyle}>
        
//         {/* Badge inside the card */}
//         <span style={badgeStyle}>PRODUCT SPECIFICATIONS</span>

//         {/* Content inside the card */}
//         <div style={contentGridStyle}>
          
//           {/* Image Side */}
//           <div style={imageWrapperStyle}>
//             {/* REPLACE THIS SVG WITH YOUR ACTUAL IMAGE */}
//             <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke={theme} strokeWidth="1.5" opacity="0.3">
//               <rect x="3" y="3" width="18" height="18" rx="2" />
//               <circle cx="8.5" cy="8.5" r="1.5" />
//               <path d="M21 15l-5-5L5 21" />
//             </svg>
//           </div>

//           {/* Text/Specs Side */}
//           <div style={specsWrapperStyle}>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Available in 3 kW and 5 kW models with MPPT technology for optimised solar generation.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Maximum efficiency of up to 97.5% and MPPT efficiency above 99%.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Wi-Fi and RS485 communication for compatible remote monitoring systems.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>IP65 enclosure protection against dust and water ingress.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Quiet operation with noise below 25 dB, ideal for residential rooftop applications.</span>
//             </div>
//           </div>

//         </div>

//         {/* Button */}
//         <button
//           style={buttonStyle}
//           onClick={handleClick}
//           onMouseEnter={(e) => handleHover(e, true)}
//           onMouseLeave={(e) => handleHover(e, false)}
//         >
//           Explore Inverters
//           <span style={{ fontSize: '18px', lineHeight: 1 }}>→</span>
//         </button>

//       </div>
//     </section>
//   );
// };


// ---------

// const BessSection = () => {
//   const navigate = useNavigate();
//   const theme = '#a20000'; // CORRECTED: 6-digit hex code
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkScreen = () => setIsMobile(window.innerWidth <= 768);
//     checkScreen();
//     window.addEventListener('resize', checkScreen);
//     return () => window.removeEventListener('resize', checkScreen);
//   }, []);

//   const sectionStyle = {
//     padding: isMobile ? '60px 16px' : '80px 24px',
//     backgroundColor: '#fafafa',
//     fontFamily: '"Inter", "Segoe UI", Roboto, Arial, sans-serif',
//   };
  
//   const containerStyle = {
//     maxWidth: '1200px',
//     margin: '0 auto',
//     display: 'grid',
//     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//     gap: isMobile ? '32px' : '60px',
//     alignItems: 'center',
//     padding:"10px"
//   };

//   const imageWrapperStyle = {
//     position: 'relative',
//     borderRadius: '16px',
//     overflow: 'hidden',
//     backgroundColor: '#f5f5f5',
//     aspectRatio: '4/3',
//     boxShadow: '0 20px 60px rgba(162, 0, 0, 0.12)',
//     order: isMobile ? 2 : 2,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     background: 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)'
//   };

//   const contentStyle = {
//     paddingRight: isMobile ? '0' : '20px',
//     order: isMobile ? 1 : 1,
//     textAlign: isMobile ? 'center' : 'left'
//   };

//   const tagStyle = {
//     display: 'inline-block',
//     padding: '8px 18px',
//     backgroundColor: 'rgba(162, 0, 0, 0.08)', // Matches #a20000
//     color: theme,
//     borderRadius: '100px',
//     fontSize: '13px',
//     fontWeight: '700',
//     letterSpacing: '0.5px',
//     textTransform: 'uppercase',
//     marginBottom: '24px'
//   };

//   const headingStyle = {
//     fontSize: isMobile ? '32px' : '42px',
//     fontWeight: '800',
//     color: '#0a0a0a',
//     lineHeight: '1.15',
//     marginBottom: '20px',
//     letterSpacing: '-0.02em'
//   };

//   const descStyle = {
//     fontSize: isMobile ? '16px' : '17px',
//     lineHeight: '1.7',
//     color: '#555',
//     marginBottom: '24px'
//   };

//   const specListStyle = {
//     listStyle: 'none',
//     padding: 0,
//     margin: '0 0 32px 0',
//     textAlign: 'left'
//   };

//   const specItemStyle = {
//     fontSize: '15px',
//     lineHeight: '1.6',
//     color: '#444',
//     padding: '10px 0',
//     borderBottom: '1px solid #f0f0f0',
//     display: 'flex',
//     alignItems: 'flex-start',
//     gap: '10px'
//   };

//   const buttonStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '10px',
//     padding: '16px 36px',
//     backgroundColor: theme, // Uses #a20000
//     color: '#ffffff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '16px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 4px 14px rgba(162, 0, 0, 0.25)', // Matches #a20000
//     width: isMobile ? '100%' : 'auto',
//     justifyContent: 'center'
//   };

//   const handleClick = () => navigate('/bess');

//   const handleHover = (e, isHovering) => {
//     if (isMobile) return;
//     if (isHovering) {
//       e.currentTarget.style.transform = 'translateY(-2px)';
//       e.currentTarget.style.boxShadow = '0 8px 24px rgba(162, 0, 0, 0.35)';
//     } else {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = '0 4px 14px rgba(162, 0, 0, 0.25)';
//     }
//   };

//   return (
//     <section style={sectionStyle}>
//       <div style={containerStyle}>

//         <div style={contentStyle}>
//           <span style={tagStyle}>BESS · Energy Storage</span>
//           <h2 style={headingStyle}>
//             Battery Energy Storage Systems
//           </h2>
//           <p style={descStyle}>
//             Gautam Solar's Battery Energy Storage Systems (BESS) provide reliable and scalable
//             energy backup for commercial, industrial, and utility-scale applications. Built with
//             advanced LFP chemistry and a modular architecture, these systems ensure stable power
//             supply, seamless integration, and long operational life.
//           </p>
//           <ul style={specListStyle}>
//             <li style={specItemStyle}>
//               <span style={{ color: theme, fontWeight: '700' }}>→</span>
//               Modular architecture — scalable for changing project requirements
//             </li>
//             <li style={specItemStyle}>
//               <span style={{ color: theme, fontWeight: '700' }}>→</span>
//               LFP chemistry with multi-layer protection and real-time monitoring
//             </li>
//             <li style={specItemStyle}>
//               <span style={{ color: theme, fontWeight: '700' }}>→</span>
//               C&I solution: 125 kW / 261.2 kWh, 90% DoD, IP55, liquid cooling
//             </li>
//             <li style={specItemStyle}>
//               <span style={{ color: theme, fontWeight: '700' }}>→</span>
//               Utility-scale solution: GS-5000-LC, 5,015 kWh, 8,000 cycles, IP55
//             </li>
//             <li style={{ ...specItemStyle, borderBottom: 'none' }}>
//               <span style={{ color: theme, fontWeight: '700' }}>→</span>
//               Communication options for EMS, HMI, and remote monitoring
//             </li>
//           </ul>
//           <button
//             style={buttonStyle}
//             onClick={handleClick}
//             onMouseEnter={(e) => handleHover(e, true)}
//             onMouseLeave={(e) => handleHover(e, false)}
//           >
//             Explore BESS
//             <span style={{ fontSize: '18px', lineHeight: 1 }}>→</span>
//           </button>
//         </div>

//         <div style={imageWrapperStyle}>
//           <img
//             src="bessSection.webp"
//             alt="Gautam Solar BESS"
//             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//           />
//         </div>
//       </div>
//     </section>
//   );
// };